export default [
  {
    label: 'Prorrogação',
    value: 'PRORROGACAO',
    color: '#caf0f8',
    textColor: '#0096c7',
  },
  {
    label: 'Empréstimo',
    value: 'EMPRESTIMO',
    color: '#c7f9cc',
    textColor: '#57cc99',
  },
];
